import { HelpCircleFreeIcons, SquareLock02FreeIcons } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Modal } from 'antd';
import { NButton } from '@next-is-free-monorepo/nif-web-components';

import { Link } from '@tanstack/react-router';

interface WelcomeComponentsProps {
}

const WelcomeComponents = () => {
  return (
    <Modal centered closable={false} open={true} footer={null}>
      <div className={`flex flex-col items-center flex-1`}>
        <div className={`bg-slate-100 w-full flex justify-center items-center h-[200px] rounded-xl`}>
          <p className={'text-6xl'}>
            🎉
          </p>
        </div>
        <p className={'text-2xl font-bold mt-10'}>Benvenuto su Next is Free!</p>
        <p>Completa il profilo per renderlo visibile agli altri.</p>
        <Link to={'/customize'} className={'mt-10'}>
          <NButton>Completa il Profilo</NButton>
        </Link>
      </div>
    </Modal>
  );
};
export default WelcomeComponents;
